import { Formik, Form } from "formik";
import { useState, useEffect } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Header from "../../header/Header";
import { SpinnerCircle, SpinnerCircleMini } from "../../../atoms/spinner/Spinner";
import Footer from "../../footer/Footer";
import ModalMensajes from "../../modals/modalMensajes/ModalMensajes";
import ModalPresentar from "../../modals/modalPresentar/modalPresentar";
import {
  getSolicitudPDF,
  presentarSolicitud,
  validarPresentada,
} from "../../../services/DatoPersonalService";
import { base64ToBlob } from "../../../../utils/Utils";

const PresentarBorradorActos = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const [hidePresentar, setHidePresentar] = useState(false);
  const [show, setShow] = useState({ mensaje: false, modalPresentar: false });
  const [loading, setLoading] = useState(false);
  const [loadingPresentar, setLoadingPresentar] = useState(false);
  const [solicitud, setSolicitud] = useState("");
  const [disablePresentar, setDisablePresentar] = useState(false)


  useEffect(() => {
    if (location?.state?.tipoActo) {
      localStorage.setItem("tipoActo", location.state.tipoActo);
    }
  }, [location?.state?.tipoActo]);

  const tipoActo = localStorage.getItem("tipoActo");
  const presentarBorrador = (xsolactadm) => {
    

    if (tipoActo) {
      validarPresentada(xsolactadm, tipoActo).then((data) => {
        if (data.estado) {
          presentarSolicitud(
            xsolactadm,
            tipoActo,
            base64ToBlob(solicitud)
          ).then((data) => {
            setDisablePresentar(true)
            setShow({
              mensaje: true,
              content:
                typeof data === "object" && !Array.isArray(data)
                  ? "Se ha presentado correctamente"
                  : data,
              tipo: "tituloModal",
              aviso: false,
              stateParams: { accesoPDF: true },
              destinoCerrar: tipoActo === "s1" && (typeof data === "object" && !Array.isArray(data)) ? 
              "/variacionDatosPersonales" : 
              tipoActo === "z9" && (typeof data === "object" && !Array.isArray(data)) ? 
              "/reconNivelCarrera" :"#",
              
            });
          });
          setLoadingPresentar(false);
        } else {
          setShow(prev => ({
            ...prev,
            mensaje: true,
            content: data.descripcion,
            tipo: "tituloModal",
            aviso: false,
            destinoCerrar: null,
            destinoAviso: null
          }));
          setLoadingPresentar(false);
        }
      });
    }
  };

  const handleClose = () => {
    setShow({ mensaje: false, modalPresentar: false });
    setLoadingPresentar(false);
  };

  useEffect(() => {
    getSolicitudPDF(params?.id, location?.state?.tipoActo).then((data) => {

     // si el service devuelve "Error: ..." o no hay data, cortamos spinner
      if (!data || data.toString().startsWith("Error:")) {
        setHidePresentar(true);
        setLoading(true);
        return;
      }

     
       //  OK: mostrar botón
        setHidePresentar(false);

        var reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = function () {
          var base64data = reader.result;
          
          
          setSolicitud(base64data);
          setLoading(true);
        };
    // si falla el FileReader, cortamos spinner
      reader.onerror = function () {
        setHidePresentar(true);
        setLoading(true);
      };
        
      
    });
  }, [params?.id, location?.state?.tipoActo]);

  return (
    <>
      <Header />
      <div
        className="container-fluid d-flex flex-column card mt-5"
        id="inicio"
        role="main"
        data-landmark-index="4"
      >
        {loading ? (
          <div className="my-auto">
            <div className="container-login fondo">
              <div className="tituloSolicitud">
                <div className="d-flex align-items-center flex-column">
                  <h2 className="tituloPagina">
                    {location?.state?.tipoActo === "s1"
                      ? "Acto S1 Variación de datos personales"
                      : location?.state?.tipoActo === "z9"
                        ? "Acto Z9 Reconocimiento de Nivel de Carrera"
                        : ""}
                  </h2>
                </div>

                <div className="datosPersonalesCarrera d-flex flex-column m-2">
                  <h3 className="tituloPagina noBg">3. Presentar</h3>
                  <div className="separador"></div>

                  <div className="formulario">
                    <Formik
                      initialValues={{}}
                      validate={() => ({})}
                      onSubmit={() => {
                        setLoadingPresentar(true);
                        setShow({
                          mensaje: true,
                          content:
                            "Se va a presentar la solicitud. Una vez presentada no se podrá realizar modificaciones.",
                          contentBold: "¿Estás seguro/a?",
                          tipo: "tituloModal",
                          funcion: presentarBorrador,
                          valorFuncion: params.id,
                          aviso: true,
                          destinoAviso: null,
                          destinoCerrar: null
                        });
                      }}
                    >
                      {() => (
                        <Form>
                          <div className="card p-3 my-3">
                            <div className="row justify-content-center">
                              {/* Columna botones */}
                              <div className="mb-3 row justify-content-center">
                                {/* <div className="col col-md-4 mb-1">
                                  <button
                                    id="firmarSolicitudCarrera"
                                    className="btn btn-outline-primary "
                                    type="button"
                                    onClick={() => {
                                      cargarAutoFirma();
                                      const soloBase64 = solicitud.split(",")[1];
                                      const coordenadas =
                                        location?.state?.tipoActo === "s1"
                                          ? {
                                            x1: 60,
                                            y1: 370,
                                            x2: 500,
                                            y2: 420,
                                            page: 1,
                                          }
                                          : location?.state?.tipoActo === "z9"
                                            ? {
                                              x1: 60,
                                              y1: 280,
                                              x2: 500,
                                              y2: 230,
                                              page: 2,
                                            }
                                            : "";
                                      firmar(coordenadas, soloBase64, (firmaB64) => {
                                        if (firmaB64 && typeof firmaB64 === "string") {
                                          const pdfFirmado = `data:application/pdf;base64,${firmaB64}`;
                                          setSolicitud(pdfFirmado);
                                        } else {
                                          alert("Error al obtener la firma.");
                                        }
                                      });
                                    }}
                                  >
                                    <i className="fa-solid fa-pencil"></i> Firmar
                                  </button>
                                </div> */}
                                {!hidePresentar && (
                                <div className="col col-md-4">
                                  <button
                                    id="grabarSolicitudCarrera"
                                    className="btn btn-success"
                                    type="submit"
                                    disabled={disablePresentar}
                                  >
                                    {loadingPresentar ? (
                                      <div className="d-flex justify-content-center">
                                        <SpinnerCircleMini clases={"background-border"} />
                                      </div>
                                    ) : (
                                      <>
                                        <i className="fa-solid fa-arrow-up-from-bracket"></i>{" "}
                                        Presentar
                                      </>
                                    )}
                                  </button>
                                </div>
                                )}



                              </div>

                              {/* Columna PDF */}
                              <div className="col-12 col-md-8">
                                <object
                                  data={solicitud}
                                  type="application/pdf"
                                  height="500"
                                  width="100%"
                                  aria-label="PDF del borrador"
                                  className="rounded"
                                  name="sol"
                                >
                                  <span className="rojo">Error al obtener el PDF</span>
                                </object>
                              </div>
                            </div>

                            {/* Botón volver */}
                            <div className=" col-md-2 my-2">
                              <button
                                id="volver"
                                className="btnRed rojo btn-danger rounded w-md-auto"
                                type="button"
                                onClick={() => {
                                  if (tipoActo === "s1") {
                                    navigate("/variacionDatosPersonales");
                                  } else if (tipoActo === "z9") {
                                    navigate("/reconNivelCarrera");
                                  }
                                }}
                              >
                                <i className="fa-solid fa-rotate-left"></i> Volver
                              </button>
                            </div>
                          </div>


                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column my-auto">
            <SpinnerCircle />
          </div>
        )}
      </div>
      <Footer />

      {show.mensaje && (<>
        {}

        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          content={show.content}
          content2={show.content2}
          tipo={show.tipo}
          aviso={show.aviso}
          funcion={show.funcion}
          valorFuncion={show.valorFuncion}
          contentBold={show.contentBold}
          destinoCerrar={show.destinoCerrar}
          destinoAviso={show.destinoAviso}
          stateParams={show.stateParams}
        />
      </>
      )}

      {show.modalPresentar && (
        <ModalPresentar
          show={true}
          handleClose={handleClose}
          valores={show.valores}
          destinoCerrar={show?.destinoCerrar}
        />
      )}
    </>
  );
};

export default PresentarBorradorActos;
